import { render } from "./PatientDocListItem.vue?vue&type=template&id=122fa331"
import script from "./PatientDocListItem.vue?vue&type=script&lang=js"
export * from "./PatientDocListItem.vue?vue&type=script&lang=js"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__